export default "__VITE_ASSET__DUrkAmT3__"